export default {
	"8a7c658f1509e28d4eedc3cf176bc35f": "Sorry, the payment method has changed"
}
